import React, { Component } from "react";
import { connect } from "react-redux";
import {
  getFeaturedProducts,
  getRecommendedProducts,
  getRelatedProducts
} from "../actions/productActions";
import ProductCard from "../components/ProductCard";
import { withRouter } from "react-router";
import _ from "lodash";
//import OwlCarousel from 'react-owl-carousel2';
import TinySlider from "tiny-slider-react";
import { withTranslation } from 'react-i18next';
import 'tiny-slider/dist/tiny-slider.css';

class ProductsSlider extends Component {
    constructor(props) {
        super(props);
        this.state = { productId: 0 };

    }

    loadProducts(id) {
        this.setState({ productId: id });
    if (this.props.isRelated) {
        this.props.getRelatedProducts(this.props.productId);
    } else if (this.props.isRecommended) {
        this.props.getRecommendedProducts(this.props.productId);
    } else {
        this.props.getFeaturedProducts(this.props.count);
    }
  }

    getComponentInfo() {
        const { t } = this.props;

    if (this.props.isRelated) {
      return {
        products: this.props.relatedProducts.items,
          title: t("Related Products")  
      };
    } else if (this.props.isRecommended) {
      return {
        products: this.props.recommendedProducts.items,
          title: t("Recommended Products ")  
      };
    } else {
      return {
        products: this.props.featuredProducts.items,
          title: t("Featured Products") 
      };
    }
  }

    componentDidMount() {
 
        if (this.state.productId !== this.props.productId) {
            this.loadProducts(this.props.productId);
        }
    }
    componentDidUpdate(prevProps, prevState) {
        const prevProductId = prevProps.productId;
        const nextProductId = this.props.productId;
        if (prevProductId !== nextProductId) {
            this.loadProducts(nextProductId);
        }
  }


  render() {
    const { settings } = this.props;
    const componentInfo = this.getComponentInfo();
    const products = componentInfo.products;
    if (_.isEmpty(products)) return <div />;

    //const options = {
    //  items: 3,
    //  loop: false,
    //  dots: true,
    //  margin: 0,
    //  autoplay: false,
    //  autoplayTimeout: 5000,
    //  nav: true,
    //  navText: [
    //    "<i class='fa fa-chevron-left'></i>",
    //    "<i class='fa fa-chevron-right'></i>"
    //    ],
    //  responsive: {0:{items:1},576:{items:2},768:{items:2},991:{items:3},1200:{items:3}}
    //};

    var productsList = products.map(product => (
      <ProductCard
            key={product.id}
            isHorizontal={false}
            product={product}
            settings={settings}
            listName={componentInfo.title}
            listId={componentInfo.title}
            style={{ position: "relative" }}
            className=""
      />
    ));


    //return (
    //  <section className="container padding-top-3x padding-bottom-3x">
    //    <h3 className="text-center mb-30">{componentInfo.title}</h3>
    //    <OwlCarousel ref="car" options={options} >
    //      {productsList}
    //    </OwlCarousel>
    //  </section>
    //  );

      const sliderSettings = {
          nav: false,
          mouseDrag: true,
          items: 4,
          slideBy: 1,
          autoplay: false,
          gutter: 10,
          nav: true,
          navPosition: "bottom",
          mode: 'carousel',
          controls: false,
          loop: false,
          responsive: {
              320: {
                  items: 1
              },
              640: {
                  edgePadding: 20,
                  gutter: 20,
                  items: 2
              },
              700: {
                  gutter: 30
              },
              900: {
                  items: 3
              }
          }
         
      };

      return (
          <section className="container padding-top-3x padding-bottom-3x">
              <h3 className="text-center mb-30">{componentInfo.title}</h3>
              <TinySlider ref="car" settings={sliderSettings}>
                  {productsList}
              </TinySlider>
          </section>
      );
     
  }
}

function mapStateToProps( {  featuredProducts, relatedProducts, recommendedProducts, settings }, ownProps) {
    return {
    featuredProducts,
    relatedProducts,
    recommendedProducts,
    settings,
    ...ownProps
  };
}

export default withTranslation()(withRouter(
  connect(mapStateToProps, {
    getFeaturedProducts,
    getRecommendedProducts,
    getRelatedProducts
  }, null, { forwardRef: true })(ProductsSlider)
));
